import { criticalNoCallPrefix } from 'infrastructure/consts/critical-no-call';

import type { TCriticalBloodPressureModal, TModalNames } from '../types';

interface Props {
  idx: string | number;
  type: TCriticalBloodPressureModal;
  modalName: TModalNames;
}
export const useStoreModalValue = <TInitValues extends object>({
  modalName,
  idx,
  type,
}: Props) => {
  const localStorageFormKey = `${criticalNoCallPrefix}${modalName}_${idx}_${type}`;
  const storedData = localStorage.getItem(localStorageFormKey);
  const parsedData: TInitValues | null = storedData
    ? JSON.parse(storedData)
    : null;

  const setModalValuesToStorage = (values: TInitValues) => {
    localStorage.setItem(localStorageFormKey, JSON.stringify(values));
  };

  return {
    parsedData,
    setModalValuesToStorage,
  };
};
